import { ADD_EMAIL_INTEGRATION, ADD_EMAIL_INTEGRATION_FAILED, ADD_EMAIL_INTEGRATION_SUCCESS, GET_EMAIL_INTEGRATION, GET_EMAIL_INTEGRATION_FAILED, GET_EMAIL_INTEGRATION_SUCCESS,GET_EMAIL_TEST,GET_EMAIL_TEST_SUCCESS,GET_EMAIL_TEST_FAILED } from "./actionTypes"
  
  const initialState = {
    configurationLoading:false,
    addOrUpdateSuccess:null,
    addOrUpdatedFailed:null,
    emailConfigurationDetails:null,
    emailConfigurationDetailsFailed:null,
    emailTest:null,
    emailTestFailed:null
  
  }
  
  const emailIntegrationReducer = (state = initialState, action) => {
    switch (action.type) {
      case ADD_EMAIL_INTEGRATION:
        state = {
          ...state,
          configurationLoading:true,
    addOrUpdateSuccess:null,
    addOrUpdatedFailed:null
        }
        break
      case ADD_EMAIL_INTEGRATION_SUCCESS:
        state = {
          ...state,
          configurationLoading:false,
    addOrUpdateSuccess:action.payload,
    addOrUpdatedFailed:null
        }
        break
      case ADD_EMAIL_INTEGRATION_FAILED:
        state = { ...state, configurationLoading:false,
            addOrUpdateSuccess:null,
            addOrUpdatedFailed:action.payload}
        break
        case GET_EMAIL_INTEGRATION:
        state = {
          ...state,
          configurationLoading:true,
          emailConfigurationDetails:null,
          emailConfigurationDetailsFailed:null
        }
        break
      case GET_EMAIL_INTEGRATION_SUCCESS:
        state = {
          ...state,
          configurationLoading:false,
          emailConfigurationDetails:action.payload,
          emailConfigurationDetailsFailed:null
        }
        break
      case GET_EMAIL_INTEGRATION_FAILED:
        state = { ...state, configurationLoading:false,
          emailConfigurationDetails:null,
          emailConfigurationDetailsFailed:action.payload}
        break
        case GET_EMAIL_TEST:
        state = {
          ...state,
          configurationLoading:true,
          emailTest:null,
    emailTestFailed:null
  
        }
        break
      case GET_EMAIL_TEST_SUCCESS:
        state = {
          ...state,
          configurationLoading:false,
          emailTest:action.payload,
    emailTestFailed:null
  
        }
        break
      case GET_EMAIL_TEST_FAILED:
        state = { ...state, configurationLoading:false,
          emailTest:null,
    emailTestFailed:action.payload
  
         }
        break
  
  
     
        
  
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default emailIntegrationReducer
  